import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { formatRelative } from '@/lib/utils'

const SEVERITY_DOT: Record<string, string> = {
  info:    '#EF9F27',
  success: '#1D9E75',
  warning: '#EF9F27',
  error:   '#E24B4A',
}

export function AgentActivity() {
  const { data = [] } = useQuery({ queryKey: ['agent-activity'], queryFn: api.agentActivity })

  return (
    <section className="border border-border rounded-md p-3 min-w-0">
      <h2 className="text-sm font-medium mb-2.5">Agent activity</h2>
      <ul className="flex flex-col gap-2.5">
        {data.slice(0, 5).map((a) => (
          <li key={a.id} className="flex gap-2 text-xs leading-snug">
            <span
              className="w-1.5 h-1.5 rounded-full mt-1 shrink-0"
              style={{ background: SEVERITY_DOT[a.severity] ?? '#888780' }}
            />
            <div className="min-w-0">
              <div className="text-ink-primary">{a.summary}</div>
              <div className="text-ink-tertiary">
                {a.agent_name} · {formatRelative(a.created_at)}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
